import * as PIXI from 'pixi.js';
import CardContainer from './cardContainer';
import AssetsLoader from '../utils/assetsLoader';
import { RESOLUTION } from '../utils/commonUtils';

export default class MainDeckContainer extends PIXI.Container {
    constructor(mainDeckCount, isOpponent = false) {
        super();

        const mainDeckTexture = PIXI.Assets.get(AssetsLoader.eDefaultAssetsAliases.MAIN_DECK);
        const mainDeckSprite = new PIXI.Sprite(mainDeckTexture);
        mainDeckSprite.anchor.set(0.5, 1);
        mainDeckSprite.x = !isOpponent ? -7*RESOLUTION : 7*RESOLUTION;
        mainDeckSprite.y = 15*RESOLUTION;
        if (isOpponent) {
            mainDeckSprite.scale.x = -1;
        }
        this.addChild(mainDeckSprite);

        const mainDeckText = new PIXI.Text({
            text: mainDeckCount.toString(),
            style: {
                fontFamily: 'Fugaz One',
                fontSize: 45*RESOLUTION,
                fill: '#ffffff',
                stroke: { color: '#000000', width: 10*RESOLUTION },
            },
        });
        mainDeckText.anchor.set(0.5, 1);
        mainDeckText.y = 7;
        this.addChild(mainDeckText);
        this.updateText(mainDeckCount.toString());
    }

    updateText(text) {
        const mainDeckText = this.children[1];
        mainDeckText.text = text;
    }
}
